module.exports = __webpack_public_path__ + "img/lan_tour_route_04.60ec3a5d.jpg";